import dayjs from 'dayjs';
import { createNamespacedHelpers } from 'vuex';
import { showConfirmSwal, showSuccessSwal } from '@/util/swal';
import ImageService from '@/services/image.service';
import SkeletonLoadingImage from '@/components/shared/SkeletonLoadingImage/SkeletonLoadingImage.vue';
import checkImageName from '../../../util/checkImageName';
const historyImagesMapper = createNamespacedHelpers('history/image');
const historyMapper = createNamespacedHelpers('history');
const authMapper = createNamespacedHelpers('global/auth');
const modelMapper = createNamespacedHelpers('history/model');
const GOOD_CLASS = '0';
const MAX_LENGTH_OF_NAME = 25;
export default {
	name: 'ImagePreview',

	components: {
		SkeletonLoadingImage,
	},

	data() {
		return {
			GOOD_CLASS: GOOD_CLASS,
			isShowOption: false,
		};
	},

	props: {
		image: {
			type: Object,
		},

		idx: {
			type: Number,
		},

		isDetectedImage: {
			type: Boolean,
		},
		isOptionImage: {
			type: Boolean,
			default: true,
		},
	},

	computed: {
		...authMapper.mapState(['username']),
		...modelMapper.mapState(['model', 'trainable']),
		...historyImagesMapper.mapState(['dateStart', 'dateEnd']),
		noCheckBox: {
			get() {
				return this.$store.state.history.noCheckBox;
			},
			set(value) {
				this.$store.commit('history/UPDATE_NO_CHECKBOX', value);
			},
		},
	},

	filters: {
		splitLongName(name) {
			return name.slice(0, MAX_LENGTH_OF_NAME) + '....' + name.split('.').pop();
		},

		localDateString(date) {
			if (date.includes('+') || date.includes('Z')) {
				return dayjs(date).format('YYYY/MM/DD HH:mm:ss');
			}
			return dayjs(date + 'Z').format('YYYY/MM/DD HH:mm:ss');
		},
	},

	methods: {
		checkImageName,
		...historyMapper.mapMutations(['UPDATE_SHOW_RETRAIN_TAG']),
		...historyImagesMapper.mapActions([
			'setIsTraning',
			'retrieveAllImages',
			'showOptionsImage',
			'closeOptionsImage',
		]),
		...historyImagesMapper.mapMutations([
			'SET_RETRAIN',
			'SET_LIST_ID_RETRAIN',
			'SET_REMOVE_LIST_RETRAIN',
		]),

		onChooseImage() {
			this.$emit('on-click-image', this.image);
		},

		openOptions(id) {
			this.isShowOption = true;
			this.showOptionsImage(id);
		},

		closeOption() {
			if (this.isShowOption !== true) {
				this.closeOptionsImage();
			}
			this.isShowOption = false;
		},

		onClickRetrainOption() {
			if (!this.image.isRetraining) this.showOptions = false;
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: true,
			});

			this.SET_LIST_ID_RETRAIN({ id: this.image?._id?.$oid, isRetraining: true });
		},
		onClickUnretrainOption() {
			if (this.image.isRetraining) this.showOptions = false;
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: false,
			});
			this.SET_REMOVE_LIST_RETRAIN(this.image?._id?.$oid);
		},

		onChange(e, image) {
			this.$emit('onCheckImage', { value: e.target.checked, image });
			this.setIsTraning({
				id: this.image?._id?.$oid,
				isRetraining: e.target.checked,
			});
			this.$forceUpdate();
		},

		eventBusListeners() {
			this.$eventBus.$on('force-update', () => {
				this.$forceUpdate();
			});
		},
		onDeleteImgDetect() {
			this.$emit('on-delete-img', this.image._id.$oid);
		},
	},

	mounted() {
		this.eventBusListeners();
	},
};
